export default class CtaNews {
  constructor() {
    this.cookieName = 'ctanewsclosed';
    this.selector = '[data-cta-news]';

    return this;
  }

  init() {
    this.elements = document.querySelectorAll(this.selector);

    // Bail if no elements found
    if (this.elements.length < 1) {
      return this;
    }

    [...this.elements].forEach((element) => {
      const cookieId = element.dataset.ctaNews;
      const cookieName = `${this.cookieName}-${cookieId}`;

      // Request the cookie
      const cookie = this.getCookie(cookieName);

      if (cookie) {
        this.deleteOverlay(element);

        return this;
      }

      this.showOverlay(element);

      this.addEventListeners(element);

      return this;
    });

    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();

    return null;
  }

  setCookie(name) {
    document.cookie = `${name}=true; expires=Fri, 31 Dec 2030 23:59:59 GMT`;

    return this;
  }

  showOverlay($element) {
    $element.classList.add('-visible');

    return this;
  }

  deleteOverlay($element) {
    $element.remove();

    return this;
  }

  addEventListeners($element) {
    const $button = $element.querySelector('.close');

    $button.addEventListener('click', () => {
      const cookieId = $element.dataset.ctaNews;
      const cookieName = `${this.cookieName}-${cookieId}`;

      this.setCookie(cookieName);
      this.deleteOverlay($element);
    });
  }
}
